import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CloseTicketPage from "./features/tickets/CloseTicketPage";
import LocationCapturePage from "./features/tickets/LocationCapturePage";
import ErrorBoundary from "./components/ErrorBoundary";
import { logError, logUnhandledRejection } from "./lib/discordLogger";
import "./styles/base.css";
import "./styles/auth.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/dialer.css";
import "./styles/close-ticket.css";

// ── Global error handlers ────────────────────────────────
window.addEventListener("error", (event) => {
  logError(event.error || new Error(event.message), `${event.filename}:${event.lineno}:${event.colno}`);
});

window.addEventListener("unhandledrejection", (event) => {
  logUnhandledRejection(event.reason);
});
// ────────────────────────────────────────────────────────

function isCloseTicketRoute() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const action = params.get("action");
  return /^\/tickets\/[^/]+\/?$/.test(path) && (action === "close" || action === "reopen");
}

function isLocationRoute() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  return /^\/location\/?$/.test(path) && !!params.get("token");
}

const rootEl = document.getElementById("root");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      {isLocationRoute() ? <LocationCapturePage /> : isCloseTicketRoute() ? <CloseTicketPage /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>,
);
